import React from 'react';
import { Paper, TableContainer, Table, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import { ColumnDefinitionType } from './type';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    paddingTop: theme.spacing(1.5),
    boxShadow: 'none'
  },
  container: {
    maxHeight: 190
  },
  message: {
    margin: theme.spacing(4, 3, 4, 3),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: theme.spacing(8)
  }
}));

type GenericTableProps<T, K extends keyof T> = {
  records: Array<T>;
  columns: Array<ColumnDefinitionType<T, K>>;
  stickHeader?: boolean;
  onSelect: (value: T) => void;
  noRecordsMessage?: React.ReactNode | string;
  isShowColumns?: boolean;
};

export const GenericTable = <T, K extends keyof T>({
  records,
  columns,
  stickHeader = false,
  onSelect,
  noRecordsMessage,
  isShowColumns = true
}: GenericTableProps<T, K>): React.ReactElement => {
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader={stickHeader}>
          {isShowColumns && <TableHeader columns={columns} />}
          {(!records || records.length === 0) && (
            <Typography variant="subtitle1" className={classes.message}>
              {noRecordsMessage}
            </Typography>
          )}
          <TableBody records={records} columns={columns} onSelect={onSelect} />
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default GenericTable;
